module.exports = __webpack_public_path__ + "static/media/placeholder-2.aa0a33fa.svg";